import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import EventPackageSectionForm from './EventPackageSectionForm'

const EventPackageSectionEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.eventPackageSections.editPackage'}>
      <Edit>
        <EventPackageSectionForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default EventPackageSectionEdit
